import type { FC } from "react";
import { createContext, useCallback, useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { useLanguageContext } from "./language/language";

type NavigationContextState = {
  navigate: (path: string, appendLanguageSetting?: boolean) => void;
};

const NavigationContext = createContext<NavigationContextState>({ navigate: () => {} });

export const NavigationContextProvider: FC = (props: any) => {
  const navigateFunc = useNavigate();
  const { languageSetting } = useLanguageContext();
  const [searchParams] = useSearchParams();

  const navigate = useCallback(
    (path: string, appendLanguageSetting = true) => {
      const parsedPath = path.startsWith("/") ? path : `/${path}`;

      navigateFunc({
        pathname: (appendLanguageSetting ? `/${languageSetting}` : "") + `${parsedPath}`,
        search: `?${searchParams.toString()}`,
      });
    },
    [languageSetting, navigateFunc, searchParams],
  );

  return <NavigationContext.Provider value={{ navigate }}>{props.children}</NavigationContext.Provider>;
};

export const useNavigationContext = () => {
  return useContext(NavigationContext);
};
